import React, { useEffect, useRef } from 'react';

interface FontPreview {
  font: string | any;
  name: string;
}

const FontPreview = ({ font, name }: FontPreview) => {
  const divRef = useRef<any>(null);
  const pRef = useRef<any>(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.style.setProperty('font-family', font.fontFamily, 'important');
      divRef.current.style.setProperty('font-size', '24px', 'important');
    }
    if (pRef.current) {
      pRef.current.style.setProperty('font-family', font.fontFamily, 'important');
    }
  }, [font]);

  return (
    <>
      <div ref={divRef}>
        <p ref={pRef}>{name || 'Preview'}</p>
      </div>
    </>
  );
};

export default FontPreview;
